<div class="mobile-profile-view">
  <mat-accordion class="menu-group" id="sidebar-my-profile">
    <mat-expansion-panel #profileMenuGroup hideToggle>
      <mat-expansion-panel-header class="profile-header-responsive">
        <mat-panel-title class="menu-item-text w-100 m-0">
          <div class="profile-flex-container text-white">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center justify-content-center profile-avatar">
                <span>{{ initials() }}</span>
              </div>
              <span class="fw-semibold tracking-wide profile-text-name">{{ displayName() }}</span>
            </div>
            <mat-icon id="expand-icon" [ngClass]="{ expanded: profileMenuGroup.expanded }"
              >expand_more</mat-icon
            >
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="menu-item level-1 mobile-logout-row" (click)="onLogoutClick()">
        <span class="menu-item-text text-white">Logout</span>
        <mat-icon class="text-white logout-icon">logout</mat-icon>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="desktop-profile-view">
  <button
    mat-button
    [matMenuTriggerFor]="menu"
    class="bg-transparent border-0 menu-btn w-100"
    (menuOpened)="menuOpen.set(true)"
    (menuClosed)="menuOpen.set(false)"
  >
    <div class="profile-flex-container text-white">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center justify-content-center profile-avatar">
          <span>{{ initials() }}</span>
        </div>
        <span class="fw-semibold tracking-wide profile-text-name">{{ displayName() }}</span>
      </div>
      <mat-icon id="expand-icon" [ngClass]="{ expanded: menuOpen() }">expand_more</mat-icon>
    </div>
  </button>

  <mat-menu #menu="matMenu" class="profile-menu">
    <button mat-menu-item class="menu-item level-1 desktop-logout-row" (click)="onLogoutClick()">
      <span class="text-white">Logout</span>
      <mat-icon class="text-white logout-icon">logout</mat-icon>
    </button>
  </mat-menu>
</div>
